import { render, staticRenderFns } from "./birthdayBenefit.vue?vue&type=template&id=0efde82b&scoped=true"
import script from "./birthdayBenefit.vue?vue&type=script&lang=js"
export * from "./birthdayBenefit.vue?vue&type=script&lang=js"
import style0 from "./birthdayBenefit.vue?vue&type=style&index=0&id=0efde82b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efde82b",
  null
  
)

export default component.exports